import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bfddde0c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfddde0c')) {
      api.createRecord('bfddde0c', component.options)
    } else {
      api.reload('bfddde0c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bfddde0c&", function () {
      api.rerender('bfddde0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/error/index.vue"
export default component.exports